<template lang="pug">
div
  el-divider 人员范围
  el-form-item(label-width="0")
    el-radio-group(v-model="candateRangeType", @change="clearRange")
      el-radio(v-for="{ cnName, id } in rangeOptions", :key="id", :label="id") {{ cnName }}
  el-form-item(label-width="0")
    el-button(size="mini", v-if="showRangeAdd", @click="openRange", icon="el-icon-plus")
    div
      el-tag.mt-4.mr-4(v-for="{ name, userId } in candateValues", closable, :key="userId", size="small", @close="closeCandate(userId)") {{ name }}
  el-divider 默认人员
  el-form-item(label-width="0")
    el-radio-group(v-model="defaultUserType")
      el-radio(v-for="{ id, cnName } in userOptions", :key="id", :label="id") {{ cnName }}
    .mt-4(v-if="!isCurUser")
      el-button(@click="addUser") 添加人员
      user-list.mt-4(v-if="defaultUser.length", :list="defaultUser", @delete="removeUser")
  el-divider 列表样式
  el-form-item(v-if="!isSingle", label="人员样式")
    el-radio-group(v-model="line")
      el-radio(v-for="{ id, cnName } in itemDisplayOptions", :key="id", :label="id") {{ cnName }}
  el-form-item(label="人员显示")
    el-checkbox(v-for="{ id, cnName } in layoutOptions", :key="id", v-model="_self[id]") {{ cnName }}
  el-divider 关联更新
  field-setting(v-if="!isSingle", key="assignToId", v-model="assignToId", label="用户id")
  field-setting(v-model="assignToName", key="assignToName", label="姓名")
  field-setting(v-model="assignToUserName", key="assignToUserName", label="工号")
</template>
<script>
import { USER_ENUM } from "./utils.js";
import UserList from "@/CommonDP/components/userList/index.vue";
import { mapVFOptions, settingMixin } from "@/CommonDP/VForm/utils";
import { openMember } from "@/CommonDP/components/chooseMember/leftCom.js";

export default {
  components: { UserList },
  mixins: [settingMixin],
  data() {
    return {
      userOptions: [
        { id: USER_ENUM.cur_user, cnName: "当前用户" },
        { id: USER_ENUM.frameWork, cnName: "指定人员" }
      ],
      itemDisplayOptions: [
        { id: "inline", cnName: "行内" },
        { id: "block", cnName: "块级" }
      ],
      rangeOptions: [
        { id: USER_ENUM.range_all, cnName: "全部" },
        { id: USER_ENUM.cur_dept, cnName: "当前用户部门" },
        { id: USER_ENUM.frameWork, cnName: "组织架构" },
        { id: USER_ENUM.prj, cnName: "当前项目" },
        { id: USER_ENUM.dept, cnName: "指定部门", filter: true },
        { id: USER_ENUM.role, cnName: "系统角色", filter: true },
        { id: USER_ENUM.specRole, cnName: "专业角色", filter: true }
      ]
    };
  },
  computed: {
    ...mapVFOptions("candateValues", "candateRangeType", "defaultUserType", "defaultUser", "showUserName", "showAvatar", "line", "assignToId", "assignToName", "assignToUserName"),
    showRangeAdd() {
      const { candateRangeType: type } = this;
      return this.rangeOptions.some(({ filter, id }) => filter && type === id);
    },
    // 是否单选组件
    isSingle() {
      return !!this.optionModel.single;
    },
    layoutOptions() {
      return [
        { id: "showAvatar", cnName: "显示头像" },
        { id: "showUserName", cnName: "显示工号" }
      ];
    },
    isCurUser() {
      return this.defaultUserType === USER_ENUM.cur_user;
    }
  },
  methods: {
    async addUser() {
      const { defaultUser: list } = this;
      const props = {
        filterOneself: false,
        codePri: ["User"],
        max: this.isSingle ? 1 : Infinity,
        usersList: list
      };
      const user = await openMember(props);
      this.updateList(user);
    },
    async removeUser(id) {
      await this.$confirm("确认删除?", "警告", { type: "warning" });
      const { defaultUser: fieldModel } = this;
      const list = fieldModel.filter(({ userId }) => userId !== id);
      this.updateList(list);
    },
    closeCandate(id) {
      const { candateValues: list } = this;
      this.candateValues = list.filter(({ userId }) => userId !== id);
    },
    updateList(list) {
      this.defaultUser = list;
    },
    clearRange() {
      this.candateValues = [];
    },
    async openRange() {
      let data;
      const { candateRangeType: type, candateValues: list } = this;
      const props = {
        filterOneself: false,
        usersList: list
      };
      switch (type) {
        case USER_ENUM.dept: {
          props.codePri = ["Dept"];
          data = (await openMember(props)) || [];
          break;
        }
        case USER_ENUM.role: {
          props.codePri = ["SystemRole"];
          data = (await openMember(props)) || [];
          break;
        }
        case USER_ENUM.specRole: {
          props.codePri = ["SpecRole"];
          data = (await openMember(props)) || [];
          break;
        }
        default:
          data = [];
          break;
      }
      this.candateValues = data;
    }
  }
};
</script>
<style lang="scss" scoped src="./index.scss">
</style>
